import { Component, Input } from '@angular/core';

import { RefStatut } from 'src/app/data/habilitation/models/statut.ref.model';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-statut-badge',
    templateUrl: './statut-badge.component.html',
    styleUrls: ['./statut-badge.component.scss'],
    imports: [NgClass],
    standalone: true
})
export class StatutBadgeComponent {
    @Input() statut: RefStatut;
}
